module.exports = __webpack_public_path__ + "img/1.ece5c429.jpg";